import React from 'react';
// import { Navigate } from "react-router-dom";

// import {
//   Grid, 
// } from "@mui/material";

import API from "@dndUtilities/system_api";

// import StringBox from "../../components/input/strings/StringBox";
import ObjectIndex from "@components/Navigation/ObjectIndex";
// import LetterLinks from "../../components/Navigation/LetterLinks";

// type Props = { }

const api = API.getInstance();

export default function UserIndexPage() {
  // const [navigateTo, setNavigateTo] = useState<string | null>(null);
  // const [searchString, setSearchString] = useState<string>("");
  // const [startLetter, setStartLetter] = useState<string>("");

  // const getFilter = () => {
  //   const newFilter: any = {};
    
  //   if (startLetter !== "") {
  //     newFilter["name*startsWith"] = startLetter;
  //   } else {
  //     delete newFilter["name*startsWith"];
  //   }
    
  //   if (searchString !== "") {
  //     newFilter["$or"] = [
  //       { "name*includes": searchString },
  //       { "description*includes": searchString }
  //     ];
  //   }

  //   return newFilter;
  // };

  // if (navigateTo !== null) {
  //   return <Navigate to={navigateTo} />;
  // }
  
  if (api.user && api.user.is_admin) {
    return (
      <ObjectIndex 
        data_type="user"
        // log_it
      />
    ); 
    // return (
    //   <Grid container spacing={0} direction="row">
    //     <Grid item xs={12}>
    //       <ObjectIndex 
    //         data_type="user"
    //       />
    //     </Grid>
    //     <Grid item xs={12}>
    //       <LetterLinks onChange={setStartLetter} />
    //     </Grid>
    //   </Grid>
    // ); 
  }

  return <></>;
  
  // return <Navigate to="/labs" />;
}